import BlogAdmin from '@/views/blog/pages/BlogAdmin.vue';
import BlogArticle from '@/views/blog/pages/BlogArticle.vue';
import BlogHome from '@/views/blog/pages/BlogHome.vue';
import BlogWiki from '@/views/blog/pages/BlogWiki.vue';
import requireAdminAccess from '@/router/guards';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    name: 'blog',
    path: '/blog',
    component: BlogHome,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'blog news',
    path: '/blog/news',
    component: BlogHome,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'blog articles',
    path: '/blog/articles',
    component: BlogHome,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'blog-admin',
    path: '/admin-editor',
    component: BlogAdmin,
    beforeEnter: requireAdminAccess,
    meta: {
      layout: 'full',
      auth: true
    }
  },
  {
    name: 'blog articles article',
    path: '/blog/articles/:articleId',
    props: true,
    component: BlogArticle,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'blog news article',
    path: '/blog/news/:articleId',
    props: true,
    component: BlogArticle,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'blog wiki article',
    path: '/wiki/help/:articleId',
    props: true,
    component: BlogArticle,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  },
  {
    name: 'wiki help',
    path: '/wiki/help',
    component: BlogWiki,
    meta: {
      layout: 'full',
      auth: true,
      alwaysScrollTop: true
    }
  }
];
export default routes;
